var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDuplicate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7V7.625C5 7.72917 4.96354 7.81771 4.89062 7.89062C4.81771 7.96354 4.72917 8 4.625 8H0.375C0.270833 8 0.182292 7.96354 0.109375 7.89062C0.0364583 7.81771 0 7.72917 0 7.625V1.875C0 1.77083 0.0364583 1.68229 0.109375 1.60938C0.182292 1.53646 0.270833 1.5 0.375 1.5H1.5V6.125C1.5 6.36458 1.58333 6.57292 1.75 6.75C1.92708 6.91667 2.13542 7 2.375 7H5ZM5 1.625C5 1.72917 5.03646 1.81771 5.10938 1.89062C5.18229 1.96354 5.27083 2 5.375 2H7V6.125C7 6.22917 6.96354 6.31771 6.89062 6.39062C6.81771 6.46354 6.72917 6.5 6.625 6.5H2.375C2.27083 6.5 2.18229 6.46354 2.10938 6.39062C2.03646 6.31771 2 6.22917 2 6.125V0.375C2 0.270833 2.03646 0.182292 2.10938 0.109375C2.18229 0.0364583 2.27083 0 2.375 0H5V1.625ZM6.89062 1.14062C6.96354 1.21354 7 1.30208 7 1.40625V1.5H5.5V0H5.59375C5.69792 0 5.78646 0.0364583 5.85938 0.109375L6.89062 1.14062Z",
    fill: "#7F7F7F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDuplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/duplicate.c9ace271.svg";
export { ForwardRef as ReactComponent };